import AdditonalMenuMeetings from "../components/Panel/NavMenu/AdditionalMenuMeetings.vue";
import AdditonalMenuRegister from "../components/Panel/NavMenu/AdditionalMenuRegister.vue";
import AdditionalMenuMeetingTheme from "../components/Panel/NavMenu/AdditionalMenuMeetingTheme.vue";
import AdditionalMenuResidentPortal from "../components/Panel/NavMenu/AdditionalMenuResidentPortal.vue";

export const NavLinksData = [
    {
        id: 0,
        name: 'com.file.nav-data.management',
        abbr: "zarzadzanie",
        accesLevel: 0,
        elemNameId: "nav_management",
        links: [
            {
                id: 0,
                name: 'com.file.nav-data.main-panel',
                abbr: "panel-glowny",
                link: "/home",
                routerName: "home",
                icon_src: "home.svg",
                elemNameId: "nav_main_panel"
            },
            {
                id: 10,
                name: 'com.file.nav-data.sessions',
                abbr: "posiedzenia",
                icon_src: "posiedzenia.svg",
                additionalMenu: AdditonalMenuMeetings,
                link: "/sessions/search?page=1&itemsPerPage=10",
                routerName: "sessionSearchRoute",
                elemNameId: "nav_sessions"
            },
            {
                id: 20,
                name: 'com.file.nav-data.sessions-templates',
                abbr: "szablony-posiedzen",
                icon_src: "szablon-posiedzenia.svg",
                additionalMenu: AdditionalMenuMeetingTheme,
                elemNameId: "nav_session_templates",
            },
            {
                id: 30,
                name: 'com.file.nav-data.contacts',
                abbr: "kontakty",
                link: "/kontakty",
                routerName: "contact",
                icon_src: "users.svg",
                elemNameId: "nav_contacts"
            },
            {
                id: 35,
                name: 'com.file.nav-data.calendar',
                abbr: "calendar",
                link: "/calendar",
                routerName: "app-new-calendar",
                icon_src: "calendar-days.svg",
                elemNameId: "nav_calendar"
            },
            {
                id: 40,
                name: 'com.file.nav-data.register',
                abbr: "rejestr",
                link: "/rejestr",
                icon_src: "rejestr.svg",
                additionalMenu: AdditonalMenuRegister,
                elemNameId: "nav_register"
            },
            {
                id: 50,
                name: 'com.file.nav-data.interpellations',
                abbr: "interpelacje-i-zapytania",
                link: "/interpellations",
                routerName: "interpellations",
                icon_src: "message.svg",
                elemNameId: "nav_interpellations"
            },
            {
                id: 60,
                name: 'com.file.nav-data.transmission',
                target: "_blank",
                abbr: "transmission",
                link: "/transmission",
                icon_src: "signal-stream-white.svg",
                elemNameId: "nav_transmission"
            },
            {
                id: 70,
                name: 'com.file.nav-data.resident-portal',
                abbr: 'portal-mieszkanca',
                icon_src: 'building-columns.svg',
                additionalMenu: AdditionalMenuResidentPortal,
                elemNameId: 'nav_resident_portal'
            },
        ],
    },
    {
        id: 1,
        name: 'com.file.nav-data.communication',
        abbr: "komunikacja",
        accesLevel: 0,
        elemNameId: "nav_communication",
        links: [
            {
                id: 0,
                name: 'com.file.nav-data.announcement',
                abbr: "komunikaty",
                link: "/announcements",
                routerName: "announcement",
                icon_src: "contact.svg",
                elemNameId: "nav_announcement"
            },
            {
                id: 10,
                name: 'com.file.nav-data.news',
                abbr: "aktualnosci",
                link: "/news",
                routerName: "news",
                icon_src: "news.svg",
                elemNameId: "nav_news"
            },
            {
                id: 20,
                name: 'com.file.nav-data.sms',
                abbr: "wiadomosci-sms",
                link: "/sms",
                routerName: "sms",
                icon_src: "message-sms.svg",
                elemNameId: "nav_sms"
            },
            {
                id: 30,
                name: 'com.file.nav-data.email',
                abbr: "wiadomosci-e-mail",
                link: "/email",
                routerName: "email",
                icon_src: "envelope.svg",
                elemNameId: "nav_email"
            },
        ],
    },
    {
        id: 2,
        name: 'com.file.nav-data.tools',
        abbr: "narzedzia",
        accesLevel: 0,
        elemNameId: "nav_tools",
        links: [
            {
                id: 0,
                name: 'com.file.nav-data.doc-repo',
                abbr: "repozytorium-dokumentow",
                link: "/dokumenty",
                routerName: "doc",
                icon_src: "directory.svg",
                elemNameId: "nav_doc_repo"
            },
            {
                id: 10,
                name: 'com.file.nav-data.presence-reports',
                abbr: "raporty-obecnosci",
                link: "/raport",
                routerName: "presence",
                icon_src: "circle-chart.svg",
                elemNameId: "nav_presence_reports"
            },
            {
                id: 20,
                name: 'com.file.nav-data.user-activity',
                abbr: "aktywnosc-uzytkownikow",
                link: "/aktywnosc",
                routerName: "activity",
                icon_src: "user_activiti.svg",
                elemNameId: "nav_user_activity"
            },
        ],
    },
];
